import React, { useRef, useState } from 'react';
import ENUMS from '../../../enums';
import ShowForPermission from '../../../components/ShowForPermission';
import styles from './styles.scss';
import DatePicker from '../../../components/FormElements/DatePicker/DatePicker';

const IncomingReservesListFilter = props => {
  let formRefrence = useRef();
  let [fromDate, setFromDate] = useState(' ');
  let [toDate, setToDate] = useState(' ');
  let [creatorFullNamePart, setCreatorFullNamePart] = useState('');
  let [, setSelectedStatusCheckbox] = useState([]);
  let [suspended, setSuspended] = useState();
  let [trackingNumberPart, setTrackingNumberPart] = useState();
  let [cafeNamePart, setCafeNamePart] = useState();

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setTrackingNumberPart('');
    setCreatorFullNamePart('');
    setCafeNamePart('');
    setSelectedStatusCheckbox(null);
    setSuspended('null');
    setFromDate(' ');
    setToDate(' ');
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => props.applyFilters(event)}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div className="d-flex col-12 justify-content-start p-0 align-items-center">
            <div className="d-flex col-7 justify-content-around mx-1 py-3 p-0">
              <DatePicker
                marge={true}
                name="fromDate"
                onChange={value => setFromDate(value)}
                value={fromDate}
                className="col p-0 date-picker-input start border rounded py-2 col-6"
                placeholder="از تاریخ"
              />
              <DatePicker
                marge={true}
                name="toDate"
                onChange={value => setToDate(value)}
                value={toDate}
                className="col p-0 date-picker-input end border rounded py-2 col-6"
                placeholder="تا تاریخ"
              />
            </div>
          </div>
          <div className="d-flex justidy-content-between px-1">
            <div className="d-flex flex-column col-4 mx-1 py-2 h-50">
              <input
                onChange={event => setCreatorFullNamePart(event.target.value)}
                value={creatorFullNamePart || ''}
                name="creatorFullNamePart"
                type="text"
                className="form-control col-12"
                placeholder={locales('tables.requestor')}
                maxLength={ENUMS.MAX_LENGTH.fullName}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small>
            </div>

            <div className="d-flex flex-column col-4 mx-1 py-2 h-50">
              <input
                onChange={event => setTrackingNumberPart(event.target.value)}
                value={trackingNumberPart || ''}
                name="trackingNumberPart"
                type="text"
                className="form-control col-12"
                placeholder={locales('tables.trackingCode')}
                maxLength={ENUMS.MAX_LENGTH.trackingNumber}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small>
            </div>
            <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_AHEAD_RESERVES_FOR_ADMIN}>
              <div className="d-flex flex-column col-4 mx-1 py-2 h-50">
                <input
                  onChange={event => setCafeNamePart(event.target.value)}
                  value={cafeNamePart || ''}
                  name="cafeNamePart"
                  type="text"
                  className="form-control col-12"
                  placeholder={locales('fields.cafe.name')}
                  maxLength={ENUMS.MAX_LENGTH.cafeName}
                />
                <small style={{ color: '#ccc' }}>{locales('maxLength.30')}</small>
              </div>
            </ShowForPermission>
          </div>
          <div className="d-flex justidy-content-between px-1 my-3">
            <div className="col-3">
              <span className="col-2 text-center filter-field-label">{locales('tables.suspended')}</span>
              <select
                name="suspended"
                id="suspended"
                className={styles.switchWithDropDown}
                value={suspended}
                onChange={e => setSuspended(e.target.value)}
              >
                <option value="null">{locales('labels.both')}</option>
                <option value="true">{locales('labesl.with.suspended')}</option>
                <option value="false">{locales('labesl.without.suspended')}</option>
              </select>
            </div>
            <div className="d-flex col-8 justify-content-end mx-1 py-2">
              <span className="col-2 text-center d-flex align-items-center">
                {locales('tables.status')} :{' '}
              </span>
              <div className="col-10 p-0 d-flex justify-content-center align-items-center">
                {ENUMS.CAFE_RESERVATION.list.slice(2, 5).map((reserveStatus, index) => (
                  <div className={`col-${12 / 3} d-flex p-0`} key={index}>
                    <input
                      type="checkbox"
                      value={reserveStatus.value}
                      name={`status`}
                      id={`status-${index}`}
                      className="my-2"
                    />
                    <label className="my-2 mx-1" htmlFor={`status-${index}`}>
                      {reserveStatus.title}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-12 d-flex justify-content-end p-0">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button
              type="submit"
              id="apply-filter-btn-incomingReservation"
              className="btn btn-success w-5 mx-2"
            >
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

export default IncomingReservesListFilter;
